const esc = (s = '') => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

const L = {
  en: { h2: 'Where to eat — our picks', intro: 'These are places we take our own guests.', dry: 'Alcohol-free', wet: 'Halal food, alcohol also served', partner: 'Partner restaurant', sep: ', ' },
  ar: { h2: 'أين تأكل — اختياراتنا', intro: 'هذه أماكن نصطحب إليها ضيوفنا بأنفسنا.', dry: 'خالٍ من الكحول', wet: 'طعام حلال، مع تقديم المشروبات الكحولية', partner: 'مطعم شريك', sep: '، ' },
};

function nameHtml(r, isAr) {
  const name = esc(r.name);
  const linked = r.website ? `<a href="${esc(r.website)}" target="_blank" rel="nofollow noopener noreferrer">${name}</a>` : name;
  return isAr ? `<span dir="ltr">${linked}</span>` : linked;
}

function row(r, isAr) {
  const l = isAr ? L.ar : L.en;
  const area = isAr ? (r.area_ar || r.area) : r.area;
  const desc = isAr ? (r.desc_ar || r.desc_en) : r.desc_en;
  const partner = r.partner ? ` <em>(${l.partner})</em>` : '';
  return `<p${isAr ? ' dir="rtl"' : ''}><strong>${nameHtml(r, isAr)}${l.sep}${esc(area)}</strong>${partner} — ${esc(desc)}</p>`;
}

export function restaurantPicksHtml(restaurants = [], isAr = false) {
  const l = isAr ? L.ar : L.en;
  const picks = restaurants.filter(r => r.in_halal_post);
  if (!picks.length) return '';
  const dry = picks.filter(r => r.alcohol === 'not_served');
  const wet = picks.filter(r => r.alcohol !== 'not_served');
  let html = `<h2>${l.h2}</h2><p>${l.intro}</p>`;
  if (dry.length) html += `<h3>${l.dry}</h3>` + dry.map(r => row(r, isAr)).join('');
  if (wet.length) html += `<h3>${l.wet}</h3>` + wet.map(r => row(r, isAr)).join('');
  return html;
}

export const RESTAURANT_PICKS_MARKER = '<!--RESTAURANT_PICKS-->';
